import React from "react";
import { useSelector } from "react-redux";

const PaypalDetails = () => {
  const paypalInfo = useSelector(state => state.paypalInfo);
  return (
    <>
      <div className="">
        Email:{" "}
        <span className="fw-bold">{paypalInfo?.getEmail()}</span>
      </div>
      <div>
        <span className="fw-bold">Connected</span>
      </div>
    </>
  );
};

export default PaypalDetails;
